import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="profile"
export default class extends Controller {
  static targets = ['bio', 'bioToggleButton', 'copyButton'];

  connect() {
    // Check if the bio target exists before proceeding
    if (this.hasBioTarget) {
      // Use requestAnimationFrame to ensure layout is calculated
      requestAnimationFrame(() => {
        const bioElement = this.bioTarget;
        // Check if the content height is greater than the visible height
        if (bioElement.scrollHeight > bioElement.clientHeight) {
          // If it is, make the toggle button visible
          if (this.hasBioToggleButtonTarget) {
            this.bioToggleButtonTarget.classList.remove('hidden');
          }
        }
      });
    }
  }

  copyUrl() {
    const url = window.location.href;
    navigator.clipboard.writeText(url).then(() => {
      const oldTip = this.copyButtonTarget.dataset.tip;
      this.copyButtonTarget.dataset.tip = 'Link copied to clipboard';
      setTimeout(() => {
        this.copyButtonTarget.dataset.tip = oldTip;
      }, 1000);
    });
  }

  toggleBio() {
    const bio = this.bioTarget;
    const button = this.bioToggleButtonTarget;

    if (bio.classList.contains('line-clamp-3')) {
      bio.classList.remove('line-clamp-3');
      button.textContent = 'Show less';
    } else {
      bio.classList.add('line-clamp-3');
      button.textContent = 'Show more';
    }
  }
}
